import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { groupSchemaObject } from '../../Data'
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { collectionTypeSchemaObject } from '../../CollectionType/collectionTypeSchema';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';

const screenCode = 'COLLECTIONTYPE';


export function CollectionTypeAddEdit(props){

    const {data, edit} = props.location
    const [title, setTitle] = useState("Add Collection Type")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [product, setProduct] = useState([])
   

    const [collectiontype, setCollectionType] = useState({
        collectiontypeCode: '',
        collectiontypeName: '',
        productID: '0',
       
        isActive: true
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    
    const schema = Joi.object(collectionTypeSchemaObject).options({ allowUnknown: true })
  

    useEffect(() => {
        if (data && edit) {
            setTitle("Edit CollectionType")
            setCollectionType(data)
            setButtonName("Update")
        } else {
            setTitle("Add CollectionType")
        }
    }, [])

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [collectiontype]);

    useEffect(() => {
        trackPromise(
            getAllProductIDForDropdown()
            )
    }, [])

    useEffect(() => {
        getPermissions();
    }, []);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITCOLLECTIONTYPE');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }
        
        if (data && edit) {
            setTitle("Edit CollectionType");
            setCollectionType(data);
            setButtonName("Update");
        } else {
            setTitle("Add CollectionType");
        }
    }
    
    async function getAllProductIDForDropdown() {
        const product = await services.getAllProductIDForDropdown();
        setProduct(product);
    }

    function handleChange(e){
        const target = e.target

        if (target.name === "collectionTypeCode") {
            if(target.value.length === 3) return false
        }

        const value = target.name === 'isActive' ? target.checked: target.value
        
        const error = {...errors}
        const errorMessage = validateProperty(target, collectionTypeSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        
        setCollectionType({
            ...collectiontype,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e){
        e.preventDefault()

        const errorMessages = validate(schema, collectiontype)
        errorMessages !== null ?  setErrors(errorMessages) : setErrors({})
        if(errorMessages) return

        if (!edit) {
            
            const response = await services.saveCollectionType(collectiontype)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
        if (edit) {
            const response = await services.editData(collectiontype)
            setMessageModel({...messageModel, hidden: false, type: response.statusCode, disciption: response.message})
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if(response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({pathname: '/collectiontype'})
            }, 1500);
        }
    }

    function clearState() {
        setCollectionType({
            ...collectiontype,
            collectiontypeCode: '',
           collectiontypeName: '',
            isActive: true
        })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function modalDismissHandler() {
        setMessageModel({...messageModel, hidden: true})
    }
    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title={title}
                            isButtonEnable={true}
                            buttonText="Back to Listing"
                            path="/collectiontype"
                        />

                        <form onSubmit={(e) => handleSave(e)}>
                        <div className="card-body">
                          
                    
                                <div className="form-group row">
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Collection Type Code *" 
                                            name="collectionTypeCode"
                                            id="collectionTypeCode"
                                            value={collectiontype.collectionTypeCode}
                                            type="number"
                                            maxLength="3"
                                            onChange={(e) => handleChange(e)}/>
                                        {errors["collectionTypeCode"] && <span id="errbranchCode" className="text text-danger">{errors["collectionTypeCode"]}</span>}
                                    </div>
                                    <div className="col-md-4">
                                       
                                        <TextField fullWidth label="Collection Type Name *"
                                            name="collectionTypeName"
                                            id="collectionTypeName"
                                            value={collectiontype.collectionTypeName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["collectionTypeName"] && <span id="errbranchCode" className="text text-danger">{errors["collectionTypeName"]}</span>}
                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            value={collectiontype.productID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>

                                   
                                </div>

                               <br/>
                                <label htmlFor="switch1" >Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                    <input
                                        className="mr-2"
                                        id="isActive"
                                        switch="none"
                                        type="checkbox" 
                                        name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={collectiontype.isActive}
                                    />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                               
                                
                          

                        </div>

                        <div className="card-footer">
                                <input
                                    disabled={validate(schema, collectiontype)} 
                                    type="submit" 
                                    className="btn btn-primary" 
                                    value={buttonName} 
                                />
                                <input

                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                />
                            </div>
                              </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
